import instance from './interceptor';
import { isAuthFlag } from 'modules/common/utility/utility';

export const promoDiscountApi = {
  getPromoDiscount: async () => instance.get('/promoCode'),
}
